import { render, staticRenderFns } from "./SettingAnswerTime.vue?vue&type=template&id=6d2d7154&scoped=true&"
import script from "./SettingAnswerTime.vue?vue&type=script&lang=js&"
export * from "./SettingAnswerTime.vue?vue&type=script&lang=js&"
import style0 from "./SettingAnswerTime.vue?vue&type=style&index=0&id=6d2d7154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2d7154",
  null
  
)

export default component.exports